export default __webpack_public_path__ + "static/media/LogoVonto.9fff9d7c.svg";